import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    init() {},
    set() {},
    update() {},
    success() {},
    failure() {},
    clear() {},
  },
});

export const settingsActions = settingsSlice.actions;
export default settingsSlice.reducer;
